import * as React from "react";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "./registration.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { newUserMaker } from "../../reduxToolKit/features/allAsyncActionReducers/AllAsyncActionReducersSlice";
import Swal from "sweetalert2";
import {app,auth,database,storage} from '../../configure/firebase'
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getDatabase, ref as refdata, set } from "firebase/database";
import { getStorage, uploadBytes,ref ,getDownloadURL } from "firebase/storage";

import { Radio } from "@mui/material";
import { async } from "@firebase/util";
function Registration() {


const [dp,setdp]=React.useState();
const [doc_i,setdoc_i]=React.useState();
const [catg,setcatg]=React.useState([]);
const [min,setmin]=React.useState();

const [email,setemail]=React.useState();
const [first_name,setfirst_name]=React.useState();
const [last_name,setlast_name]=React.useState();
const [pass,setpass]=React.useState();
const [actorRole, setactorRole] = React.useState(""); 


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    newMailValid,
    currentUser,
    currentUserIsAdmin,
    currentUserIsLawyer,
    currentUserIsCustomer,
    currentUserIsActive,
    currentUserRegistration,
  } = useSelector((state) => state.mainReducer);





  const sumbit_data = async () => {

   
    if (
      email &&
      first_name &&
      last_name &&
      pass &&
      actorRole&&
      dp
    )
     {


       if (actorRole=='lawyer') {
         //for laywer 
         console.log(true,catg);

  if(doc_i && min && catg.length>0){

    


    const auth = getAuth();
    createUserWithEmailAndPassword(auth, email, pass)
      .then(async (userCredential) => {
        // Signed in 
        const user = userCredential.user;
        // ...
        toast.loading("Uploading Data")
        console.log("true",userCredential);
    let prodile_pic= document.getElementById('profile_pic').files[0];
    let document_certificate= document.getElementById('doc_i').files[0];
    let code=  'H'+ Math.floor(Math.random() * 89098990);
  let path=`lawyer/${code}`;
  let path2=`lawyer document/${code}`;

        const storage = getStorage();
        const storageRef = ref(storage, path);
        const storageRef2 = ref(storage, path2);

        // 'file' comes from the Blob or File API
         await uploadBytes(storageRef, prodile_pic)
         .then((snapshot) => {
           console.log('Uploaded a blob or file!',snapshot);
         }).
         catch((e)=>{
           alert(e)
         })
        // 'file' comes from the Blob or File API
        await uploadBytes(storageRef2, document_certificate)
        .then((snapshot) => {
          console.log('Uploaded a blob or file!',snapshot);
        }).
        catch((e)=>{
          alert(e)
        })


        getDownloadURL(ref(storage,path ))
        .then((url) => {





          getDownloadURL(ref(storage,path2 ))
          .then((url2) => {
                   console.log('url>>>>>>>>>>>>>>>',url,url2);
                    const db = getDatabase();

              set(refdata(db, 'lawyer/' + userCredential.user.uid), {
                email :email,
              first_name :first_name,
              last_name :last_name,
              dp:url,
             certificate:url2,
              approved:'no',
              category:catg,
              price:min,
              uid:userCredential.user.uid,
              type:'lawyer',
              TotalRatings:0,
              Star1:0,
              Star2:0,
              Star3:0,
              Star4:0,
              Star5:0,
              response:'no'
              });
        toast.dismiss()
        toast.success('Sucessfully Registered')
        sessionStorage.clear()
        navigate('/login')
          })
          .catch((e) => {
                alert(e)
                toast.dismiss()
          });



         
      
        })
        .catch((e) => {
              alert(e)
              toast.dismiss()
              sessionStorage.clear()
              navigate('/login')
        });
  
       
  
  
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ..
alert(errorMessage)  
sessionStorage.clear()
// navigate('/login')
      });




  }
  else {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please fill all the fields",
    });
    // sessionStorage.clear()
    // navigate('/login')
  }
} 


else {
  //for client 
  toast.loading("Uploading Data")
  const auth = getAuth();
  createUserWithEmailAndPassword(auth, email, pass)
    .then(async (userCredential) => {
      // Signed in 
      const user = userCredential.user;
      // ...
      console.log("true",userCredential);
  let prodile_pic= document.getElementById('profile_pic').files[0];
  let code=  'H'+ Math.floor(Math.random() * 89098990);
let path=`client/${code}`;
      const storage = getStorage();
      const storageRef = ref(storage, path);
     
      // 'file' comes from the Blob or File API
      await uploadBytes(storageRef, prodile_pic)
      .then((snapshot) => {
        console.log('Uploaded a blob or file!',snapshot);
      }).
      catch((e)=>{
        alert(e)
        toast.dismiss()
      })

      getDownloadURL(ref(storage,path ))
  .then((url) => {
           console.log('url>>>>>>>>>>>>>>>',url);
            const db = getDatabase();
      set(refdata(db, 'Client/' + userCredential.user.uid), {
        email :email,
      first_name :first_name,
      last_name :last_name,
      dp:url,
      uid:userCredential.user.uid,
      type:'Client'

      });
toast.dismiss()
toast.success('Sucessfully Registered')
navigate('/login')
  })
  .catch((e) => {
        alert(e)
  });
     


    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      // ..
alert(errorMessage)
    });
}
    }
    
    
    
    
    else {
         Swal.fire({
           icon: "error",
           title: "Oops...",
           text: "Please fill all the fields",
         });
       }
    
      }
  return (
    <>
      <h1 className=" reg-heading">Registered Here</h1>
      <div className="container azaab">
        <div className="row">
          <form
            className="col s12"
            id="registrationForm"
           
            style={{ background: "#0c0c0d" }}
          >
            <div className="row">
              <div className="input-field col s6">
                <input
                onChange={(e)=>{setfirst_name(e.target.value)}}
                  placeholder="First Name"
                  id="actorFirstName"
                  name="actorFirstName"
                  type="text"
                  className="validate"
                  style={{ color: "white" }}
                />
              </div>
              <div className="input-field col s6">
                <input
                  id="actorLastName"
                  onChange={(e)=>{setlast_name(e.target.value)}}

                  type="text"
                  name="actorLastName"
                  className="validate"
                  placeholder="Last Name"
                  style={{ color: "white" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <input
                  onChange={(e)=>{setemail(e.target.value)}}

                  id="actorEmail"
                  type="email"
                  name="actorEmail"
                  className="validate"
                  placeholder="Email"
                  style={{ color: "white" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <input
              onChange={(e)=>{setpass(e.target.value)}}

                  id="actorPassword"
                  type="password"
                  name="actorPassword"
                  className="validate"
                  placeholder="Password"
                  style={{ color: "white" }}
                />
                           

              </div>
            </div>
            <div className="row">
              <div className="input-field col s12" style={{color:'white'}}>
                <label  for='dp'>Select DP</label> <br/> <br/>
                <input onChange={(e)=>setdp(e.target.value)} id='profile_pic' className="file" required type="file" placeholder="Select DP" name="lawyerDP" />
                
              </div>
            </div>

            <div
              class="input-field col s12"
              backgroundColor="white"
              padding="0"
            >
              <FormControl
                variant="standard"
                sx={{
                  width: "100%",
                  borderColor: "white",
                  borderBottom: "1px solid white",
                  padding: "0px",
                  margin: "0px",
                }}
                fullWidth
              >
                <Select
                  fullWidth
                  value={actorRole}
                  onChange={(e)=>{setactorRole(e.target.value)}}
                  displayEmpty
                  sx={{
                    input: { padding: "0px 0px", margin: "0px" },
                    fieldset: { borderColor: "white" },
                    "&:hover": { borderColor: "white" },
                    color: "white",
                    svg: { color: "white" },
                  }}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value="">
                    <em>Select Your Role</em>
                  </MenuItem>
                  <MenuItem value={"lawyer"}>Lawyer</MenuItem>
                  <MenuItem value={"customer"}>Client</MenuItem>
                </Select>
              </FormControl>
            </div>
    

          </form>
          {actorRole === "lawyer" && (
            <div >
                <input id='doc_i'  className="file" type="file" 
                onChange={(e)=>{setdoc_i(e.target);}} name="lawyerpdf" /><br></br><br></br><br></br>
 <label  style={{fontSize:'16px',fontWeight:'bold'}} for='dp'>Choose case Type</label> 
     <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',width:'45%'}}>

    <p style={{marginRight:'16%'}}>
      <label>
        <input
         onChange={(e)=>{
           if (e.target.checked) {
             
             catg.push('Divorce');
           }
           else{
             const index = catg.indexOf('Divorce');
            if (index > -1) {
              catg.splice(index, 1); // 2nd parameter means remove one item only
            }
           }
        
        }}
          type="checkbox" />
        <span >Divorce</span>
      </label>
    
    </p>

    <p style={{marginRight:'16%'}}>
      <label>
        <input
         onChange={(e)=>{
          if (e.target.checked) {
            
            catg.push('Child Custody');
          }
          else{
            const index = catg.indexOf('Child Custody');
           if (index > -1) {
             catg.splice(index, 1); // 2nd parameter means remove one item only
           }
          }
       
       }}
        type="checkbox" />
        <span>Child Custody</span>
      </label>
    
    </p> 
     <p style={{marginRight:'16%'}}>
      <label>
        <input
         onChange={(e)=>{
          if (e.target.checked) {
            
            catg.push('Adoption');
          }
          else{
            const index = catg.indexOf('Adoption');
           if (index > -1) {
             catg.splice(index, 1); // 2nd parameter means remove one item only
           }
          }
       
       }}
        type="checkbox" />
        <span>Adoption</span>
      </label>
    
    </p>
    <p style={{marginRight:'16%'}}>
      <label>
        <input 
         onChange={(e)=>{
          if (e.target.checked) {
            
            catg.push('Conflicts');
          }
          else{
            const index = catg.indexOf('Conflicts');
           if (index > -1) {
             catg.splice(index, 1); // 2nd parameter means remove one item only
           }
          }
       
       }}
        type="checkbox" />
        <span>Conflicts</span>
      </label>
    
    </p>
    <p style={{marginRight:'16%'}}>
      <label>
        <input 
         onChange={(e)=>{
          if (e.target.checked) {
            
            catg.push('Spousal neglect');
          }
          else{
            const index = catg.indexOf('Spousal neglect');
           if (index > -1) {
             catg.splice(index, 1); // 2nd parameter means remove one item only
           }
          }
       
       }}
        type="checkbox" />
        <span>Spousal neglect</span>
      </label>
    
    </p>
    <p style={{marginRight:'16%'}}>
      <label>
        <input
         onChange={(e)=>{
          if (e.target.checked) {
            
            catg.push('Child Custody');
          }
          else{
            const index = catg.indexOf('Child Custody');
           if (index > -1) {
             catg.splice(index, 1); // 2nd parameter means remove one item only
           }
          }
       
       }}
        type="checkbox" />
        <span>Dowry</span>
      </label>
    
    </p>

    <input onChange={(e)=>{setmin(e.target.value)}} type='number' placeholder='Enter Your Min Charges'style={{height:'30px',width:'240px',color:'white' }}></input>
                </div>   
                  </div>
            )}
            <div className="container reg-btn">
              <button onClick={()=>{sumbit_data()}} className="btn-design">
                Submit Now{" "}
              </button>
            </div>
          <div className="row">
            <div className="col m12">
              <p className="dont-register">
                If You've already an account!
                <Link to="/login">Login</Link> Here
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Registration;
